import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AcceptanceCriterion } from '../models/acceptance-criterion.model';

@Injectable({ providedIn: 'root' })
export class AcceptanceCriteriaService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  private url(projectId: string, requirementId: string): string {
    return `${this.base}/${projectId}/requirements/${requirementId}/acceptance-criteria`;
  }

  list(projectId: string, requirementId: string): Observable<AcceptanceCriterion[]> {
    return this.http.get<AcceptanceCriterion[]>(this.url(projectId, requirementId));
  }

  create(projectId: string, requirementId: string, text: string, checked = false): Observable<AcceptanceCriterion> {
    return this.http.post<AcceptanceCriterion>(this.url(projectId, requirementId), { text, checked });
  }

  update(projectId: string, requirementId: string, criterionId: string, text: string): Observable<AcceptanceCriterion> {
    return this.http.patch<AcceptanceCriterion>(`${this.url(projectId, requirementId)}/${criterionId}`, { text });
  }

  toggleChecked(
    projectId: string,
    requirementId: string,
    criterionId: string,
    checked: boolean,
  ): Observable<AcceptanceCriterion> {
    return this.http.patch<AcceptanceCriterion>(`${this.url(projectId, requirementId)}/${criterionId}`, { checked });
  }

  delete(projectId: string, requirementId: string, criterionId: string): Observable<void> {
    return this.http.delete<void>(`${this.url(projectId, requirementId)}/${criterionId}`);
  }

  reorder(projectId: string, requirementId: string, orderedIds: string[]): Observable<AcceptanceCriterion[]> {
    return this.http.post<AcceptanceCriterion[]>(`${this.url(projectId, requirementId)}/reorder`, { orderedIds });
  }
}
